<template>

  <div>
    <van-cell-group class="cellGroup">

      <van-field :value="dataInfo.feedType" size="large" readonly required label="反馈类型" is-link arrow-direction="down" @click="feedbackClick">

      </van-field>

      <van-field class="textFieldCell" label="联系电话" clearable required size="large" v-model="dataInfo.mobile" type="number" minlength="11" placeholder="方便我们与您取得联系联系" />

      <van-field required v-model="dataInfo.content" rows="6" label="反馈内容" type="textarea" maxlength="500" placeholder="对我们的商品、服务，您还有什么建议么？您还希望在商城上买到什么？请告诉我们..." show-word-limit :autosize="autosizeobj" />
      <van-uploader v-model="fileList" multiple :max-count="1" />
    </van-cell-group>

    <div class="btn-box-feedback">
      <van-button @click="BTActionSubmit" color="rgb(214, 190, 147)" size="large" type="primary" block>提交</van-button>
    </div>

    <van-action-sheet v-model="showPicker">
      <div class="content">

        <van-picker show-toolbar :columns="columns" @cancel="showPicker = false" @confirm="onConfirm" />

      </div>
    </van-action-sheet>

  </div>

</template>





<script>
import { feedbackSubmit, storageUpload } from "@/api/index";
import { Toast, Dialog } from "vant";

export default {
  name: "feedback",
  data() {
    return {
      autosizeobj: { maxHeight: 250, minHeight: 250 },
      showPicker: false,
      columns: ["请选择反馈类型", "商品相关", "功能异常", "优化建议", "其他"],
      feedbackType: "请选择反馈类型",
      message: "",
      userPhone: "180****9761",
      SMCode: "",
      newPhoneNumber: "",
      fileList: [],
      dataInfo: {
        mobile: "", //电话
        feedType: "", //反馈类型 (商品相关,功能异常,优化建议,其他)
        content: "", //反馈内容
        hasPicture: false, //是否有图片
        picUrls: [] //图片地址
      }
    };
  },
  methods: {
    feedbackClick() {
      this.showPicker = true;
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      console.log(file);
    },
    onConfirm(value) {
      this.dataInfo.feedType = value;
      this.showPicker = false;
    },
    BTActionSubmit() {
      if (this.dataInfo.mobile == "" || this.dataInfo.mobile.length != 11) {
        Dialog.alert({
          title: "提示",
          message: "请填写正确的手机号码"
        });
        return;
      }
      Dialog.confirm({
        title: "标题",
        message: "确定提交？"
      })
        .then(() => {
          // on confirm

          if (this.fileList.length != 0) {
            let param = new FormData(); // FormData 对象
            if (this.fileList[0].file) {
              param.append("file", this.fileList[0].file); // 文件对象
            }
            storageUpload(param).then(res => {
              console.log(res);
              if (res.data.errno == 413) {
                Dialog.alert({
                  title: "提示",
                  message: "图片过大，请重新选择上传"
                });
              }

              if (res.data.errno != 0) return;
              this.dataInfo.picUrls.push(res.data.data.url);
              this.dataInfo.hasPicture = true;
              feedbackSubmit(this.dataInfo).then(res => {
                console.log(res);
                if (res.data.errno == 0) {
                  Toast("提交成功");
                  this.$router.go(-1);
                } else {
                  Dialog.alert({
                    title: "标题",
                    message: res.data.errmsg
                  });
                }
              });
            });
          } else {
            feedbackSubmit(this.dataInfo).then(res => {
              console.log(res);
              if (res.data.errno == 0) {
                Toast("提交成功");
                this.$router.go(-1);
              } else {
                Dialog.alert({
                  title: "标题",
                  message: res.data.errmsg
                });
              }
            });
          }
        })
        .catch(() => {
          // on cancel
        });
    }
  }
};
</script>


<style scoped lang="scss">
.btn-box-feedback {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding-bottom: 1rem;
  background: #fff;
  display: flex;
  justify-content: center;
}
.cellGroup {
  padding-top: 1rem;
  background-color: #f4f4f4;
  .textFieldCell {
    height: 50px;
  }
}
.van-uploader {
  width: 100%;
  padding: 1rem;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/view/person/feedback.vue